module.exports = __webpack_public_path__ + "static/media/8.af58e6b5.JPG";